<template>
    <el-dialog
            title="选择产品"
            :visible="true"
            :append-to-body=true
            width="60%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
           
            <el-form-item label="产品编号:">
                <el-input v-model="form.product_sn" clearable></el-input>
            </el-form-item>

            <el-form-item label="产品名称:">
                <el-input v-model="form.product_name" clearable></el-input>
            </el-form-item>
            <el-form-item label="产品条码:">
                <el-input v-model="form.product_bar_code" clearable></el-input>
            </el-form-item>
               <el-form-item label="产品分类:">
                     <el-select v-model="categoryOneId" @change='changeCategoryOne(categoryOneId)' placeholder="请选择">
                        <el-option
                        v-for="item in categoryOne"
                        :key="item.value"
                        :label="item.cate_name"
                        :value="item.id">
                        </el-option>
                    </el-select>
            </el-form-item>
            <el-form-item >
                     <el-select v-model="product_category_id" placeholder="请选择">
                        <el-option
                        v-for="item in categoryTwo"
                        :key="item.value"
                        :label="item.cate_name"
                        :value="item.id">
                        </el-option>
                    </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getData()">搜索</el-button>
            </el-form-item>
        </el-form>
        <!--表格-->
        <el-table
                ref="multipleTable"
                :data="tableData"
                v-loading="loading"
                height="250"
                border
                stripe
                style="width: 100%">
            <el-table-column
                    v-if="isCodeShow"
                    prop="production_batch"
                    label="生产批次号"
                    width="180"
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="product_sn"
                    label="产品编号"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="product_name"
                    width="200"
                    label="产品名称"
                    show-overflow-tooltip>
            </el-table-column>
               <el-table-column
                    prop="category_name"
                    label="产品分类"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="product_bar_code"
                    label="产品条码"
                    show-overflow-tooltip>
            </el-table-column>
                  <el-table-column
                    prop="stock_total"
                    label="库存"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    width="180"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="choose(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>

        <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="handleClose">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "selectProduct",
        data() {
            return {
                product_category_id:'',
                categoryOneId:'',
                loading:false,
                form: {
                    product_sn:'',
                    product_name:'',
                    production_batch:''
                },
                tableData: [],
                //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                isCodeShow:true,
                categoryOne:[],
                categoryTwo:[]
            }
        },
        props:{
            wareData:Object
        },
        methods:{
            //获取基础配置
            getConfigInfo(){
                this.$get('logistics', '/configs', {
                    lang: ''
                }).then(res => {
                    console.log(res);
                    if(res.data.production_batch_on_off == 0){
                        this.isCodeShow = false;

                    }else if(res.data.production_batch_on_off == 1){
                        this.isCodeShow = true;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getData(){
              
                this.loading = true;
                this.$get('logistics','/allocategoods.products', {
                    lang:'',
                    to_sn:this.wareData.to_sn ,
                    product_sn:this.form.product_sn,
                    product_name:this.form.product_name,
                    product_bar_code:this.form.product_bar_code,
                    product_category_id:this.product_category_id,
                    per_page:this.pageSize,
                    page:this.pageNo
                }).then(res => {
                    this.loading = false;
                    this.tableData = res.data;
                    this.totalSize = res.meta.total;
                }).catch(function (error) {
                    this.loading = false;
                    console.log(error);
                });
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNo = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getData();
            },
            //选择产品
            choose(row){
                if(row.stock_total==0){
                       this.$message({
                                type: 'error',
                                message: '该产品库存为0'
                            });
                    return;
                }
                this.$emit('pushData',row);
                this.$emit('handleClose');
            },
            handleClose(){
                this.$emit('handleClose');
            },
            // 获取一级产品分类
            getCategoryOne(){
                this.$get('logistics','/products.category.one').then(res=>{
                    this.categoryOne=res.data
                })
            },
            // 获取二级产品分类
            changeCategoryOne(id){
                this.product_category_id=''
                 this.$get('logistics','/products.category.two',{
                     category_id:id
                 }).then(res=>{
                    this.categoryTwo=res.data
                })
            }

        },
        created(){
            this.getConfigInfo();
            this.getData();
            this.getCategoryOne()

        }
    }
</script>
<style lang="scss" scoped>

</style>